import { useEffect, useRef, useState } from 'react';
import { contentsService } from '@/services/contents';

const useGenerateAnalysis = ({
  contentInteractionId,
  shouldGenerateAnalysis
}: {
  contentInteractionId?: string;
  shouldGenerateAnalysis?: boolean;
}) => {
  const preventReFetch = useRef(false);

  const [generatedAnalysis, setGeneratedAnalysis] = useState<null | string>(null);
  const [loadingAnalysis, setLoadingAnalysis] = useState(false);

  useEffect(() => {
    if (!shouldGenerateAnalysis || !contentInteractionId || preventReFetch.current) return;
    preventReFetch.current = true;
    setLoadingAnalysis(true);
    contentsService
      .generateAnalysis(contentInteractionId)
      .then((response) => {
        setGeneratedAnalysis(response);
      })
      .finally(() => {
        setLoadingAnalysis(false);
      });
  }, [contentInteractionId, shouldGenerateAnalysis]);

  return { generatedAnalysis, loadingAnalysis };
};

export default useGenerateAnalysis;
